import Box from "@material-ui/core/Box";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import Typography from "@material-ui/core/Typography";
import React from "react";
import All from "../halcyon/sub-components/All";
import AmenitiesGall from "../halcyon/sub-components/AmenitiesGall";
import Elevation from "../halcyon/sub-components/Elevation";
import Interior from "../halcyon/sub-components/Interior";

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      style={{ padding: 0 }} // Remove default padding
      {...other}
    >
      {value === index && (
        <Box p={0}>
          <Typography component="span">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

const StyledTabs = withStyles({
  indicator: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "#A8626C",
    height: "4px",
  },
})((props) => <Tabs {...props} />);

const StyledTab = withStyles((theme) => ({
  root: {
    textTransform: "none",
    color: "#666666",
    fontSize: "1rem",
    "&:focus": {
      color: "#A8626C",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "6px 0px", // Reduced padding for mobile
    },
  },
}))((props) => (
  <Tab
    disableRipple
    {...props}
  />
));

const useStyles = makeStyles((theme) => ({
  heading: {
    color: "#A8626C",
    fontWeight: 600,
    fontSize: "2.125rem",
    lineHeight: "2.65rem",
    margin: "0rem 0rem 0.5rem 0rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.25rem",
      lineHeight: "2rem",
    },
  },
  gg: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "1rem",
    width: "100%",
    padding: "0rem 8rem 0rem 8rem",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "0.5rem",
      margin: "0rem 0rem 1rem 0rem",
      padding: "0rem 1rem 0rem 1rem",
    },
    // [theme.breakpoints.down("lg")]: {
    //   padding: "0rem 2rem 0rem 2rem",
    // },
  },
  tabContent: {
    padding: "2.5rem 8rem 2.5rem 8rem",
    [theme.breakpoints.down("md")]: {
      padding: "0rem 1rem 0rem 1rem",
    },
  },
  sectionContainer: {
    margin: "6rem 0rem 2.5rem 0rem",
    [theme.breakpoints.down("sm")]: {
      margin: "2.5rem 0rem 2.5rem 0rem",
    },
  },
}));

const Gallery = () => {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.sectionContainer}>
      <div className={classes.gg}>
        <Typography
          className={classes.heading}
          component="span"
        >
          Gallery
        </Typography>
        <StyledTabs
          value={value}
          onChange={handleChange}
          variant="fullWidth"
          centered
        >
          <StyledTab
            label="All"
            {...a11yProps(0)}
          />
          <StyledTab
            label="Exterior"
            {...a11yProps(1)}
          />
          <StyledTab
            label="Interior"
            {...a11yProps(2)}
          />
          <StyledTab
            label="3D view"
            {...a11yProps(3)}
          />
        </StyledTabs>
      </div>
      <div className={classes.tabContent}>
        <TabPanel
          value={value}
          index={0}
        >
          <All />
        </TabPanel>
        <TabPanel
          value={value}
          index={1}
        >
          <Elevation />
        </TabPanel>
        <TabPanel
          value={value}
          index={2}
        >
          <Interior />
        </TabPanel>
        <TabPanel
          value={value}
          index={3}
        >
          <AmenitiesGall />
        </TabPanel>
      </div>
    </div>
  );
};

export default Gallery;
